// Constants used across the app: physics thresholds, timings, and UI text.

// Standard gravity, in m/s².
export const GRAVITY = 9.81

// Freefall lower bound: acceleration magnitude must exceed 80% of g.
export const FREEFALL_LOWER = 0.8 * GRAVITY

// Freefall upper bound: acceleration magnitude must stay below 120% of g.
export const FREEFALL_UPPER = 1.2 * GRAVITY

// Milliseconds of continuous freefall needed before screaming.
export const FREEFALL_WINDOW_MS = 150

// Milliseconds the scream plays and the freefall screen persists.
export const SCREAM_HOLD_MS = 5000

// Local path to the Wilhelm scream; precached by the service worker.
export const SCREAM_URL = './data/wilhelm.mp3'

export type Mode = 'waiting' | 'normal' | 'freefall' | 'denied' | 'unsupported'

export const FACES: Record<Mode, string> = {
  waiting: '(・_・)',
  normal: '(◕‿◕✿)',
  freefall: 'ಠ╭╮ಠ',
  denied: '(¬_¬)',
  unsupported: '(╯°□°)╯'
}

export const MESSAGES: Record<Mode, string> = {
  waiting: 'Tap to start',
  normal: 'Hi!',
  freefall: 'AAAAAAH!',
  denied: 'Motion access was denied',
  unsupported: "Sorry, your browser isn't supported"
}
